
export enum RatingShipmentFileTypeCd {
	CUSTOMER_SHIPMENT = 'CustomerShipment',
	XPO_SHIPMENT = 'XpoShipment'}
